







































































































import { Component, Vue, Watch, Provide, Prop } from "vue-property-decorator";
// //import { CommonReq} from "@/pbjs/xcommon/module_pb";
import { client, authorClient } from "@/api/index";
import { errorMsg, setCommon } from "@/utils/request";
import { ListUserGroupByTypeReq } from "@/pbjs/external/auth/auth_pb";
import { ExecType } from "@/pbjs/xcommon/enum_pb";
import { GetOutSourceInfoReq } from "@/pbjs/external/user/user_pb";

@Component({
  name: "system",
})
export default class addNewUserV2 extends Vue {
  @Prop() user!: any;
  @Prop() isAddNewUser!: any;
  @Prop() roleOptions!: any;
  @Provide() private nationValue: string = "";
  @Provide() private options: any = [{ value: "stuff", label: "stuff" }];
  @Provide() private token: string | null = "";
  @Provide() private rules: any = {
    email: [
      { required: true, message: "Please enter", trigger: "blur" },
      {
        min: 1,
        max: 49,
        message: "the length have to be less than 50 letter",
        trigger: "blur",
      },
    ],
    role: [{ required: true, message: "Please enter", trigger: "blur" }],
    check: [{ required: true, message: "Please enter", trigger: "blur" }],
    password: [{ required: true, message: "Please enter", trigger: "blur" }],
    employeeId: [
      { max: 14, message: "the length have to be less than 15 letter", trigger: "blur" },
    ],
    type: [{ required: true, message: "Please enter", trigger: "blur" }],
    company: [{ required: true, message: "Please enter", trigger: "blur" }],
  };
  @Provide() private editRules: any = {
    email: [
      { max: 49, message: "the length have to be less than 50 letter", trigger: "blur" },
    ],
    employeeId: [
      { max: 14, message: "the length have to be less than 15 letter", trigger: "blur" },
    ],
    // name: [{ max: 19, message: "长度小于20个字符", trigger: "blur" }]
  };
  @Provide() private newUser: any;
  @Provide() private companyOptions: any = [];
  @Provide() private compRoleOptions: any = [];

  private created() {
    this.newUser = this.user;
    this.$set(this.newUser, "companyMessage", null);

    this.token = localStorage.getItem("token");
    if (!this.isAddNewUser) {
      this.rules = this.editRules;
    }
    this.typeChange(this.newUser.type);
  }

  private typeChange(val: number) {
    this.newUser.role = "";
    if (val === 2) {
      this.$set(this.newUser, "companyMessage", null);
      this.getOutSourceInfo(2);
      this.ListUserGroupByType(ExecType.EXEC_TYPE_URGE_OUTSOURCE);
    } else if (val === 1) {
      this.$set(this.newUser, "companyMessage", null);
      // this.compRoleOptions = this.roleOptions;
      // this.$set(this.newUser, "company", []);
      this.ListUserGroupByType(ExecType.EXEC_TYPE_URGE_INTERNAL);
    } else if (val === 3) {
      this.$set(this.newUser, "companyMessage", null);
      this.ListUserGroupByType(ExecType.EXEC_TYPE_TEL_VERIFY);
    } else if (val === 4) {
      this.$set(this.newUser, "companyMessage", null);
      // this.getOutSourceInfo(4);
      this.ListUserGroupByType(ExecType.EXEC_TYPE_ROBOT);
    }else if (val === 7){
      this.$set(this.newUser, "companyMessage", null);
      // this.getOutSourceInfo(7);
      this.ListUserGroupByType(ExecType.EXEC_TYPE_PHONE_SALE);
    }else if(val === 5){
      this.$set(this.newUser, "companyMessage", null);
      this.getOutSourceInfo(5);
      this.ListUserGroupByType(ExecType.EXEC_TYPE_URGE_INTERNAL);
      
    }else if(val === 6){
      this.$set(this.newUser, "companyMessage", null);
      this.getOutSourceInfo(6);
      this.ListUserGroupByType(ExecType.EXEC_TYPE_ADMIN);

    }
  }

  private submitForm(formName: string) {
    const ref: any = this.$refs[formName];
    ref.validate((valid: boolean) => {
      if (valid) {
        this.commitUserMessage();
      } else {
        return false;
      }
    });
  }
  // 角色
  private ListUserGroupByType(ExecType: any) {
    let request: any = new ListUserGroupByTypeReq();
    request.setCommonin(setCommon());
    request.setExectype(ExecType);
    // request.setExectype(ExecType.EXEC_TYPE_TEL_VERIFY);
    authorClient.listUserGroupByType(request, {}, (err: any, response: any) => {
      if (response) {
        let data: any = response.toObject();
        if (!data.commonout || data.commonout.code == 0) {
          this.compRoleOptions = data.usergroupinfosList;
        } else if (data.code == 100100 || data.code == 100101) {
          this.$router.push("./login");
        } else {
          this.$message.error(data.commonout.errmsg);
        }
      }
      if (err) {
        errorMsg(err);
      }
    });
  }

  private getOutSourceInfo(data: any) {
    // let request: any = setCommon();
    let request: any = new GetOutSourceInfoReq();
    request.setCommonin(setCommon());
    request.setExectype(data);
    client.getOutSourceInfo(request, {}, (err: any, response: any) => {
      if (response) {
        let data: any = response.toObject();
        if (!data.commonout || data.commonout.code == 0) {
          this.companyOptions = data.companyinfosList;
          this.compRoleOptions = data.usergroupinfosList;
          if (this.user.company) {
            this.$set(this.newUser, "companyMessage", this.user.company.name);
          }
        } else if (data.code == 100100 || data.code == 100101) {
          this.$router.push("./login");
        } else {
          this.$message.error(data.commonout.errmsg);
        }
      }
      if (err) {
        errorMsg(err);
      }
    });
  }

  private findCompanyData(): any {
    this.companyOptions.forEach((item: any) => {
      if (item.id == this.newUser.companyMessage) {
        this.$set(this.newUser, "company", item);
      }
    });
  }

  private commitUserMessage() {
    this.findCompanyData();
    this.$emit("returnNewUser", this.newUser);
  }

  private resetForm(formName: string) {
    const ref: any = this.$refs[formName];
    ref.resetFields();
    this.closeAddDialog();
  }

  private closeAddDialog() {
    this.$emit("returnIsShow", false);
  }
}
